export default __webpack_public_path__ + "static/media/modely2.1cfd8d79.png";